import { render } from "./EditImageLabel.vue?vue&type=template&id=7565888c&scoped=true"
import script from "./EditImageLabel.vue?vue&type=script&lang=js"
export * from "./EditImageLabel.vue?vue&type=script&lang=js"

import "./EditImageLabel.vue?vue&type=style&index=0&id=7565888c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7565888c"]])

export default __exports__